import { render, staticRenderFns } from "./DTimer.vue?vue&type=template&id=855e5fda&scoped=true"
import script from "./DTimer.vue?vue&type=script&lang=js"
export * from "./DTimer.vue?vue&type=script&lang=js"
import style0 from "./DTimer.vue?vue&type=style&index=0&id=855e5fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e5fda",
  null
  
)

export default component.exports